<template>
  <div class="row">
    <div
      v-for="(option, index) in options"
      :key="name + '-' + index"
      :class="radioClass"
      :data-test-base-radio-buttons-stacked="name"
    >
      <input
        :id="name + '-' + index"
        v-model="selected"
        type="radio"
        :value="option"
        :data-test-base-radio-button-input="name + '-' + index"
        @input="$emit('update:modelValue', option)"
      />
      <label
        :for="name + '-' + index"
        :data-test-base-radio-button-label="name + '-' + index"
        v-html="option.label"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtons',
  inject: ['$validator'],
  emits: ['update:modelValue'],
  props: {
    name: {
      type: String,
      default() {
        return 'default-radio-button-name';
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      selected: this.value
    };
  },
  computed: {
    radioClass() {
      if (this.options.length > 2) {
        return 'small-12 medium-10 columns radio-stacked';
      }

      return 'small-12 medium-6 large-6 columns radio-stacked';
    }
  }
};
</script>
